/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-a8cbe70a.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _circle, _path105, _circle2, _path106, _circle3, _path107, _circle4, _path108, _circle5, _circle6, _circle7, _circle8, _path109, _path110, _path111, _path112, _circle9, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _circle10, _path134, _circle11, _path135, _circle12, _path136, _circle13, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _circle14, _path309, _circle15, _path310, _circle16, _path311, _circle17, _path312, _circle18, _path313, _circle19, _path314, _circle20, _path315, _circle21, _path316, _path317, _circle22, _path318, _circle23, _path319, _path320, _circle24, _path321, _circle25, _path322, _path323, _circle26, _path324, _circle27, _path325, _path326, _circle28, _path327, _circle29, _path328, _path329, _path330, _circle30, _path331, _circle31, _path332, _path333, _path334, _circle32, _path335, _circle33, _path336, _path337, _path338, _circle34, _path339, _circle35, _path340, _path341, _path342, _circle36, _path343, _circle37, _path344, _path345, _circle38, _path346, _circle39, _path347, _path348, _circle40, _path349, _circle41, _path350, _path351, _circle42, _path352, _circle43, _path353, _path354, _circle44, _path355, _circle45, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _circle46, _path397, _circle47, _path398, _circle48, _path399, _circle49, _path400, _path401, _path402, _path403, _path404;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children"],
    _excluded49 = ["children"],
    _excluded50 = ["children"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"],
    _excluded99 = ["children"],
    _excluded100 = ["children"],
    _excluded101 = ["children"],
    _excluded102 = ["children"],
    _excluded103 = ["children"],
    _excluded104 = ["children"],
    _excluded105 = ["children"],
    _excluded106 = ["children"],
    _excluded107 = ["children"],
    _excluded108 = ["children"],
    _excluded109 = ["children"],
    _excluded110 = ["children"],
    _excluded111 = ["children"],
    _excluded112 = ["children"],
    _excluded113 = ["children"],
    _excluded114 = ["children"],
    _excluded115 = ["children"],
    _excluded116 = ["children"],
    _excluded117 = ["children"],
    _excluded118 = ["children"],
    _excluded119 = ["children"],
    _excluded120 = ["children"],
    _excluded121 = ["children"],
    _excluded122 = ["children"],
    _excluded123 = ["children"],
    _excluded124 = ["children"],
    _excluded125 = ["children"],
    _excluded126 = ["children"],
    _excluded127 = ["children"],
    _excluded128 = ["children"],
    _excluded129 = ["children"],
    _excluded130 = ["children"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["children"],
    _excluded134 = ["children"],
    _excluded135 = ["children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["children"],
    _excluded139 = ["children"],
    _excluded140 = ["children"],
    _excluded141 = ["children"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["children"],
    _excluded145 = ["children"],
    _excluded146 = ["children"],
    _excluded147 = ["children"],
    _excluded148 = ["children"],
    _excluded149 = ["children"],
    _excluded150 = ["children"],
    _excluded151 = ["children"],
    _excluded152 = ["children"],
    _excluded153 = ["children"],
    _excluded154 = ["children"],
    _excluded155 = ["children"],
    _excluded156 = ["children"],
    _excluded157 = ["children"],
    _excluded158 = ["children"],
    _excluded159 = ["children"],
    _excluded160 = ["children"],
    _excluded161 = ["children"],
    _excluded162 = ["children"],
    _excluded163 = ["children"],
    _excluded164 = ["children"],
    _excluded165 = ["children"],
    _excluded166 = ["children"],
    _excluded167 = ["children"],
    _excluded168 = ["children"],
    _excluded169 = ["children"],
    _excluded170 = ["children"],
    _excluded171 = ["children"],
    _excluded172 = ["children"],
    _excluded173 = ["children"],
    _excluded174 = ["children"],
    _excluded175 = ["children"],
    _excluded176 = ["children"],
    _excluded177 = ["children"],
    _excluded178 = ["children"],
    _excluded179 = ["children"],
    _excluded180 = ["children"],
    _excluded181 = ["children"],
    _excluded182 = ["children"],
    _excluded183 = ["children"],
    _excluded184 = ["children"],
    _excluded185 = ["children"],
    _excluded186 = ["children"],
    _excluded187 = ["children"],
    _excluded188 = ["children"],
    _excluded189 = ["children"],
    _excluded190 = ["children"],
    _excluded191 = ["children"],
    _excluded192 = ["children"],
    _excluded193 = ["children"],
    _excluded194 = ["children"],
    _excluded195 = ["children"],
    _excluded196 = ["children"],
    _excluded197 = ["children"],
    _excluded198 = ["children"],
    _excluded199 = ["children"],
    _excluded200 = ["children"],
    _excluded201 = ["children"],
    _excluded202 = ["children"],
    _excluded203 = ["children"],
    _excluded204 = ["children"],
    _excluded205 = ["children"],
    _excluded206 = ["children"],
    _excluded207 = ["children"],
    _excluded208 = ["children"],
    _excluded209 = ["children"],
    _excluded210 = ["children"],
    _excluded211 = ["children"],
    _excluded212 = ["children"],
    _excluded213 = ["children"],
    _excluded214 = ["children"],
    _excluded215 = ["children"],
    _excluded216 = ["children"],
    _excluded217 = ["children"],
    _excluded218 = ["children"],
    _excluded219 = ["children"],
    _excluded220 = ["children"],
    _excluded221 = ["children"],
    _excluded222 = ["children"],
    _excluded223 = ["children"],
    _excluded224 = ["children"],
    _excluded225 = ["children"],
    _excluded226 = ["children"],
    _excluded227 = ["children"],
    _excluded228 = ["children"],
    _excluded229 = ["children"],
    _excluded230 = ["children"],
    _excluded231 = ["children"],
    _excluded232 = ["children"],
    _excluded233 = ["children"],
    _excluded234 = ["children"],
    _excluded235 = ["children"],
    _excluded236 = ["children"],
    _excluded237 = ["children"],
    _excluded238 = ["children"],
    _excluded239 = ["children"],
    _excluded240 = ["children"],
    _excluded241 = ["children"],
    _excluded242 = ["children"],
    _excluded243 = ["children"],
    _excluded244 = ["children"],
    _excluded245 = ["children"],
    _excluded246 = ["children"],
    _excluded247 = ["children"],
    _excluded248 = ["children"],
    _excluded249 = ["children"],
    _excluded250 = ["children"];
var didWarnAboutDeprecation = {};
var ChevronRight20 = /*#__PURE__*/React.forwardRef(function ChevronRight20(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
  })), children);
});
var ChevronRight16 = /*#__PURE__*/React.forwardRef(function ChevronRight16(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
  })), children);
});
var ChevronRightGlyph = /*#__PURE__*/React.forwardRef(function ChevronRightGlyph(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
  })), children);
});
var ChevronSort32 = /*#__PURE__*/React.forwardRef(function ChevronSort32(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
  })), children);
});
var ChevronSort24 = /*#__PURE__*/React.forwardRef(function ChevronSort24(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
  })), children);
});
var ChevronSort20 = /*#__PURE__*/React.forwardRef(function ChevronSort20(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
  })), children);
});
var ChevronSort16 = /*#__PURE__*/React.forwardRef(function ChevronSort16(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5zM8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
  })), children);
});
var ChevronSortDown32 = /*#__PURE__*/React.forwardRef(function ChevronSortDown32(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
  })), children);
});
var ChevronSortDown24 = /*#__PURE__*/React.forwardRef(function ChevronSortDown24(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
  })), children);
});
var ChevronSortDown20 = /*#__PURE__*/React.forwardRef(function ChevronSortDown20(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
  })), children);
});
var ChevronSortDown16 = /*#__PURE__*/React.forwardRef(function ChevronSortDown16(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
  })), children);
});
var ChevronSortUp32 = /*#__PURE__*/React.forwardRef(function ChevronSortUp32(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
  })), children);
});
var ChevronSortUp24 = /*#__PURE__*/React.forwardRef(function ChevronSortUp24(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
  })), children);
});
var ChevronSortUp20 = /*#__PURE__*/React.forwardRef(function ChevronSortUp20(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
  })), children);
});
var ChevronSortUp16 = /*#__PURE__*/React.forwardRef(function ChevronSortUp16(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
  })), children);
});
var ChevronUp32 = /*#__PURE__*/React.forwardRef(function ChevronUp32(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
  })), children);
});
var ChevronUp24 = /*#__PURE__*/React.forwardRef(function ChevronUp24(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
  })), children);
});
var ChevronUp20 = /*#__PURE__*/React.forwardRef(function ChevronUp20(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
  })), children);
});
var ChevronUp16 = /*#__PURE__*/React.forwardRef(function ChevronUp16(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
  })), children);
});
var ChevronUpGlyph = /*#__PURE__*/React.forwardRef(function ChevronUpGlyph(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z"
  })), children);
});
var Chip32 = /*#__PURE__*/React.forwardRef(function Chip32(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11V21H21V11Zm8,8H13V13h6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
  })), children);
});
var Chip24 = /*#__PURE__*/React.forwardRef(function Chip24(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11V21H21V11Zm8,8H13V13h6Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
  })), children);
});
var Chip20 = /*#__PURE__*/React.forwardRef(function Chip20(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11V21H21V11Zm8,8H13V13h6Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
  })), children);
});
var Chip16 = /*#__PURE__*/React.forwardRef(function Chip16(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11V21H21V11Zm8,8H13V13h6Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
  })), children);
});
var Choices32 = /*#__PURE__*/React.forwardRef(function Choices32(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
  })), children);
});
var Choices24 = /*#__PURE__*/React.forwardRef(function Choices24(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
  })), children);
});
var Choices20 = /*#__PURE__*/React.forwardRef(function Choices20(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
  })), children);
});
var Choices16 = /*#__PURE__*/React.forwardRef(function Choices16(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
  })), children);
});
var ChooseItem32 = /*#__PURE__*/React.forwardRef(function ChooseItem32(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
  })), children);
});
var ChooseItem24 = /*#__PURE__*/React.forwardRef(function ChooseItem24(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
  })), children);
});
var ChooseItem20 = /*#__PURE__*/React.forwardRef(function ChooseItem20(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
  })), children);
});
var ChooseItem16 = /*#__PURE__*/React.forwardRef(function ChooseItem16(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
  })), children);
});
var ChoroplethMap32 = /*#__PURE__*/React.forwardRef(function ChoroplethMap32(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
  })), children);
});
var ChoroplethMap24 = /*#__PURE__*/React.forwardRef(function ChoroplethMap24(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
  })), children);
});
var ChoroplethMap20 = /*#__PURE__*/React.forwardRef(function ChoroplethMap20(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
  })), children);
});
var ChoroplethMap16 = /*#__PURE__*/React.forwardRef(function ChoroplethMap16(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
  })), children);
});
var CicsCmas32 = /*#__PURE__*/React.forwardRef(function CicsCmas32(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
  })), children);
});
var CicsCmas24 = /*#__PURE__*/React.forwardRef(function CicsCmas24(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
  })), children);
});
var CicsCmas20 = /*#__PURE__*/React.forwardRef(function CicsCmas20(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
  })), children);
});
var CicsCmas16 = /*#__PURE__*/React.forwardRef(function CicsCmas16(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
  })), children);
});
var CicsExplorer32 = /*#__PURE__*/React.forwardRef(function CicsExplorer32(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CicsExplorer24 = /*#__PURE__*/React.forwardRef(function CicsExplorer24(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CicsExplorer20 = /*#__PURE__*/React.forwardRef(function CicsExplorer20(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CicsExplorer16 = /*#__PURE__*/React.forwardRef(function CicsExplorer16(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CicsSystemGroup32 = /*#__PURE__*/React.forwardRef(function CicsSystemGroup32(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
  })), children);
});
var CicsSystemGroup24 = /*#__PURE__*/React.forwardRef(function CicsSystemGroup24(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
  })), children);
});
var CicsSystemGroup20 = /*#__PURE__*/React.forwardRef(function CicsSystemGroup20(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
  })), children);
});
var CicsSystemGroup16 = /*#__PURE__*/React.forwardRef(function CicsSystemGroup16(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
  })), children);
});
var CicsWuiRegion32 = /*#__PURE__*/React.forwardRef(function CicsWuiRegion32(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
  })), children);
});
var CicsWuiRegion24 = /*#__PURE__*/React.forwardRef(function CicsWuiRegion24(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
  })), children);
});
var CicsWuiRegion20 = /*#__PURE__*/React.forwardRef(function CicsWuiRegion20(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
  })), children);
});
var CicsWuiRegion16 = /*#__PURE__*/React.forwardRef(function CicsWuiRegion16(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
  })), children);
});
var CicsRegion32 = /*#__PURE__*/React.forwardRef(function CicsRegion32(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
var CicsRegion24 = /*#__PURE__*/React.forwardRef(function CicsRegion24(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
var CicsRegion20 = /*#__PURE__*/React.forwardRef(function CicsRegion20(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
var CicsRegion16 = /*#__PURE__*/React.forwardRef(function CicsRegion16(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
var CicsRegionRouting32 = /*#__PURE__*/React.forwardRef(function CicsRegionRouting32(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var CicsRegionRouting24 = /*#__PURE__*/React.forwardRef(function CicsRegionRouting24(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var CicsRegionRouting20 = /*#__PURE__*/React.forwardRef(function CicsRegionRouting20(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var CicsRegionRouting16 = /*#__PURE__*/React.forwardRef(function CicsRegionRouting16(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var CicsRegionTarget32 = /*#__PURE__*/React.forwardRef(function CicsRegionTarget32(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var CicsRegionTarget24 = /*#__PURE__*/React.forwardRef(function CicsRegionTarget24(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var CicsRegionTarget20 = /*#__PURE__*/React.forwardRef(function CicsRegionTarget20(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var CicsRegionTarget16 = /*#__PURE__*/React.forwardRef(function CicsRegionTarget16(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
var Cicsplex32 = /*#__PURE__*/React.forwardRef(function Cicsplex32(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
  })), children);
});
var Cicsplex24 = /*#__PURE__*/React.forwardRef(function Cicsplex24(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
  })), children);
});
var Cicsplex20 = /*#__PURE__*/React.forwardRef(function Cicsplex20(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
  })), children);
});
var Cicsplex16 = /*#__PURE__*/React.forwardRef(function Cicsplex16(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
  })), children);
});
var CircleFilled32 = /*#__PURE__*/React.forwardRef(function CircleFilled32(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "10"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CircleFilled24 = /*#__PURE__*/React.forwardRef(function CircleFilled24(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "10"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CircleFilled20 = /*#__PURE__*/React.forwardRef(function CircleFilled20(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "10"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CircleFilled16 = /*#__PURE__*/React.forwardRef(function CircleFilled16(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "10"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var CircleSolid32 = /*#__PURE__*/React.forwardRef(function CircleSolid32(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), children);
});
var CircleSolid24 = /*#__PURE__*/React.forwardRef(function CircleSolid24(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), children);
});
var CircleSolid20 = /*#__PURE__*/React.forwardRef(function CircleSolid20(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), children);
});
var CircleSolid16 = /*#__PURE__*/React.forwardRef(function CircleSolid16(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), children);
});
var CircleDash32 = /*#__PURE__*/React.forwardRef(function CircleDash32(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
  })), children);
});
var CircleDash24 = /*#__PURE__*/React.forwardRef(function CircleDash24(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
  })), children);
});
var CircleDash20 = /*#__PURE__*/React.forwardRef(function CircleDash20(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
  })), children);
});
var CircleDash16 = /*#__PURE__*/React.forwardRef(function CircleDash16(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
  })), children);
});
var CircleFillGlyph = /*#__PURE__*/React.forwardRef(function CircleFillGlyph(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "6"
  })), children);
});
var WatsonHealthCircleMeasurement32 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement32(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
  })), children);
});
var WatsonHealthCircleMeasurement24 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement24(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
  })), children);
});
var WatsonHealthCircleMeasurement20 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement20(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
  })), children);
});
var WatsonHealthCircleMeasurement16 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement16(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
  })), children);
});
var CirclePacking32 = /*#__PURE__*/React.forwardRef(function CirclePacking32(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
  })), children);
});
var CirclePacking24 = /*#__PURE__*/React.forwardRef(function CirclePacking24(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
  })), children);
});
var CirclePacking20 = /*#__PURE__*/React.forwardRef(function CirclePacking20(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
  })), children);
});
var CirclePacking16 = /*#__PURE__*/React.forwardRef(function CirclePacking16(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
  })), children);
});
var CircleStrokeGlyph = /*#__PURE__*/React.forwardRef(function CircleStrokeGlyph(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
  })), children);
});
var QCircuitComposer32 = /*#__PURE__*/React.forwardRef(function QCircuitComposer32(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
  })), children);
});
var QCircuitComposer24 = /*#__PURE__*/React.forwardRef(function QCircuitComposer24(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
  })), children);
});
var QCircuitComposer20 = /*#__PURE__*/React.forwardRef(function QCircuitComposer20(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
  })), children);
});
var QCircuitComposer16 = /*#__PURE__*/React.forwardRef(function QCircuitComposer16(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
  })), children);
});
var Classification32 = /*#__PURE__*/React.forwardRef(function Classification32(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "19",
    r: "1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
  })), children);
});
var Classification24 = /*#__PURE__*/React.forwardRef(function Classification24(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "19",
    r: "1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
  })), children);
});
var Classification20 = /*#__PURE__*/React.forwardRef(function Classification20(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "19",
    r: "1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
  })), children);
});
var Classification16 = /*#__PURE__*/React.forwardRef(function Classification16(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "19",
    r: "1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
  })), children);
});
var ClassifierLanguage32 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage32(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
  })), children);
});
var ClassifierLanguage24 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage24(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
  })), children);
});
var ClassifierLanguage20 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage20(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
  })), children);
});
var ClassifierLanguage16 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage16(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
  })), children);
});
var Clean32 = /*#__PURE__*/React.forwardRef(function Clean32(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H26V20H20z",
    transform: "rotate(-180 23 19)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H30V28H24z",
    transform: "rotate(-180 27 27)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H28V24H22z",
    transform: "rotate(-180 25 23)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
  })), children);
});
var Clean24 = /*#__PURE__*/React.forwardRef(function Clean24(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H26V20H20z",
    transform: "rotate(-180 23 19)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H30V28H24z",
    transform: "rotate(-180 27 27)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H28V24H22z",
    transform: "rotate(-180 25 23)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
  })), children);
});
var Clean20 = /*#__PURE__*/React.forwardRef(function Clean20(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H26V20H20z",
    transform: "rotate(-180 23 19)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H30V28H24z",
    transform: "rotate(-180 27 27)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H28V24H22z",
    transform: "rotate(-180 25 23)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
  })), children);
});
var Clean16 = /*#__PURE__*/React.forwardRef(function Clean16(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H26V20H20z",
    transform: "rotate(-180 23 19)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H30V28H24z",
    transform: "rotate(-180 27 27)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H28V24H22z",
    transform: "rotate(-180 25 23)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
  })), children);
});
var Close32 = /*#__PURE__*/React.forwardRef(function Close32(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
  })), children);
});
var Close24 = /*#__PURE__*/React.forwardRef(function Close24(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
  })), children);
});
var Close20 = /*#__PURE__*/React.forwardRef(function Close20(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
  })), children);
});
var Close16 = /*#__PURE__*/React.forwardRef(function Close16(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
  })), children);
});
var CloseFilled32 = /*#__PURE__*/React.forwardRef(function CloseFilled32(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var CloseFilled24 = /*#__PURE__*/React.forwardRef(function CloseFilled24(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var CloseFilled20 = /*#__PURE__*/React.forwardRef(function CloseFilled20(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var CloseFilled16 = /*#__PURE__*/React.forwardRef(function CloseFilled16(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
  })), children);
});
var CloseOutline32 = /*#__PURE__*/React.forwardRef(function CloseOutline32(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
});
var CloseOutline24 = /*#__PURE__*/React.forwardRef(function CloseOutline24(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
});
var CloseOutline20 = /*#__PURE__*/React.forwardRef(function CloseOutline20(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
});
var CloseOutline16 = /*#__PURE__*/React.forwardRef(function CloseOutline16(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
});
var ClosedCaption32 = /*#__PURE__*/React.forwardRef(function ClosedCaption32(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
var ClosedCaption24 = /*#__PURE__*/React.forwardRef(function ClosedCaption24(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
var ClosedCaption20 = /*#__PURE__*/React.forwardRef(function ClosedCaption20(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
var ClosedCaption16 = /*#__PURE__*/React.forwardRef(function ClosedCaption16(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
var ClosedCaptionAlt32 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt32(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
var ClosedCaptionAlt24 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt24(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
var ClosedCaptionAlt20 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt20(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
var ClosedCaptionAlt16 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt16(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
var ClosedCaptionFilled32 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled32(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), children);
});
var ClosedCaptionFilled24 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled24(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), children);
});
var ClosedCaptionFilled20 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled20(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), children);
});
var ClosedCaptionFilled16 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled16(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), children);
});
var Cloud32 = /*#__PURE__*/React.forwardRef(function Cloud32(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), children);
});
var Cloud24 = /*#__PURE__*/React.forwardRef(function Cloud24(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), children);
});
var Cloud20 = /*#__PURE__*/React.forwardRef(function Cloud20(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), children);
});
var Cloud16 = /*#__PURE__*/React.forwardRef(function Cloud16(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), children);
});
var CloudAlerting32 = /*#__PURE__*/React.forwardRef(function CloudAlerting32(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), children);
});
var CloudAlerting24 = /*#__PURE__*/React.forwardRef(function CloudAlerting24(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), children);
});
var CloudAlerting20 = /*#__PURE__*/React.forwardRef(function CloudAlerting20(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), children);
});
var CloudAlerting16 = /*#__PURE__*/React.forwardRef(function CloudAlerting16(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), children);
});
var CloudAuditing32 = /*#__PURE__*/React.forwardRef(function CloudAuditing32(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), children);
});
var CloudAuditing24 = /*#__PURE__*/React.forwardRef(function CloudAuditing24(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), children);
});
var CloudAuditing20 = /*#__PURE__*/React.forwardRef(function CloudAuditing20(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), children);
});
var CloudAuditing16 = /*#__PURE__*/React.forwardRef(function CloudAuditing16(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), children);
});
var CloudDataOps32 = /*#__PURE__*/React.forwardRef(function CloudDataOps32(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
  })), children);
});
var CloudDataOps24 = /*#__PURE__*/React.forwardRef(function CloudDataOps24(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
  })), children);
});
var CloudDataOps20 = /*#__PURE__*/React.forwardRef(function CloudDataOps20(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
  })), children);
});
var CloudDataOps16 = /*#__PURE__*/React.forwardRef(function CloudDataOps16(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
  })), children);
});
var CloudDownload32 = /*#__PURE__*/React.forwardRef(function CloudDownload32(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), children);
});
var CloudDownload24 = /*#__PURE__*/React.forwardRef(function CloudDownload24(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), children);
});
var CloudDownload20 = /*#__PURE__*/React.forwardRef(function CloudDownload20(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), children);
});
var CloudDownload16 = /*#__PURE__*/React.forwardRef(function CloudDownload16(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), children);
});
var CloudLightning32 = /*#__PURE__*/React.forwardRef(function CloudLightning32(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning32']) {
      didWarnAboutDeprecation['CloudLightning32'] = true;
      console.warn("The CloudLightning32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), children);
});
var CloudLightning24 = /*#__PURE__*/React.forwardRef(function CloudLightning24(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning24']) {
      didWarnAboutDeprecation['CloudLightning24'] = true;
      console.warn("The CloudLightning24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), children);
});
var CloudLightning20 = /*#__PURE__*/React.forwardRef(function CloudLightning20(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning20']) {
      didWarnAboutDeprecation['CloudLightning20'] = true;
      console.warn("The CloudLightning20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), children);
});
var CloudLightning16 = /*#__PURE__*/React.forwardRef(function CloudLightning16(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning16']) {
      didWarnAboutDeprecation['CloudLightning16'] = true;
      console.warn("The CloudLightning16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), children);
});
var CloudLogging32 = /*#__PURE__*/React.forwardRef(function CloudLogging32(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H30V10H18zM18 12H24V14H18z"
  })), children);
});
var CloudLogging24 = /*#__PURE__*/React.forwardRef(function CloudLogging24(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H30V10H18zM18 12H24V14H18z"
  })), children);
});
var CloudLogging20 = /*#__PURE__*/React.forwardRef(function CloudLogging20(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H30V10H18zM18 12H24V14H18z"
  })), children);
});
var CloudLogging16 = /*#__PURE__*/React.forwardRef(function CloudLogging16(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H30V10H18zM18 12H24V14H18z"
  })), children);
});
var CloudMonitoring32 = /*#__PURE__*/React.forwardRef(function CloudMonitoring32(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), children);
});
var CloudMonitoring24 = /*#__PURE__*/React.forwardRef(function CloudMonitoring24(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), children);
});
var CloudMonitoring20 = /*#__PURE__*/React.forwardRef(function CloudMonitoring20(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), children);
});
var CloudMonitoring16 = /*#__PURE__*/React.forwardRef(function CloudMonitoring16(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), children);
});
var CloudOffline32 = /*#__PURE__*/React.forwardRef(function CloudOffline32(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
  })), children);
});
var CloudOffline24 = /*#__PURE__*/React.forwardRef(function CloudOffline24(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
  })), children);
});
var CloudOffline20 = /*#__PURE__*/React.forwardRef(function CloudOffline20(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
  })), children);
});
var CloudOffline16 = /*#__PURE__*/React.forwardRef(function CloudOffline16(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
  })), children);
});
var CloudRain32 = /*#__PURE__*/React.forwardRef(function CloudRain32(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain32']) {
      didWarnAboutDeprecation['CloudRain32'] = true;
      console.warn("The CloudRain32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var CloudRain24 = /*#__PURE__*/React.forwardRef(function CloudRain24(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain24']) {
      didWarnAboutDeprecation['CloudRain24'] = true;
      console.warn("The CloudRain24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var CloudRain20 = /*#__PURE__*/React.forwardRef(function CloudRain20(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain20']) {
      didWarnAboutDeprecation['CloudRain20'] = true;
      console.warn("The CloudRain20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var CloudRain16 = /*#__PURE__*/React.forwardRef(function CloudRain16(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain16']) {
      didWarnAboutDeprecation['CloudRain16'] = true;
      console.warn("The CloudRain16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var CloudServiceManagement32 = /*#__PURE__*/React.forwardRef(function CloudServiceManagement32(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), children);
});
var CloudServiceManagement24 = /*#__PURE__*/React.forwardRef(function CloudServiceManagement24(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), children);
});
var CloudServiceManagement20 = /*#__PURE__*/React.forwardRef(function CloudServiceManagement20(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), children);
});
var CloudServiceManagement16 = /*#__PURE__*/React.forwardRef(function CloudServiceManagement16(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), children);
});
var CloudSnow32 = /*#__PURE__*/React.forwardRef(function CloudSnow32(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow32']) {
      didWarnAboutDeprecation['CloudSnow32'] = true;
      console.warn("The CloudSnow32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
  })), children);
});
var CloudSnow24 = /*#__PURE__*/React.forwardRef(function CloudSnow24(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow24']) {
      didWarnAboutDeprecation['CloudSnow24'] = true;
      console.warn("The CloudSnow24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
  })), children);
});
var CloudSnow20 = /*#__PURE__*/React.forwardRef(function CloudSnow20(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow20']) {
      didWarnAboutDeprecation['CloudSnow20'] = true;
      console.warn("The CloudSnow20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
  })), children);
});
var CloudSnow16 = /*#__PURE__*/React.forwardRef(function CloudSnow16(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow16']) {
      didWarnAboutDeprecation['CloudSnow16'] = true;
      console.warn("The CloudSnow16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
  })), children);
});
var CloudUpload32 = /*#__PURE__*/React.forwardRef(function CloudUpload32(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), children);
});
var CloudUpload24 = /*#__PURE__*/React.forwardRef(function CloudUpload24(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), children);
});
var CloudUpload20 = /*#__PURE__*/React.forwardRef(function CloudUpload20(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), children);
});
var CloudUpload16 = /*#__PURE__*/React.forwardRef(function CloudUpload16(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), children);
});
var CloudApp32 = /*#__PURE__*/React.forwardRef(function CloudApp32(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
  })), children);
});
var CloudApp24 = /*#__PURE__*/React.forwardRef(function CloudApp24(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
  })), children);
});
var CloudApp20 = /*#__PURE__*/React.forwardRef(function CloudApp20(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
  })), children);
});
var CloudApp16 = /*#__PURE__*/React.forwardRef(function CloudApp16(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
  })), children);
});
var CloudCeiling32 = /*#__PURE__*/React.forwardRef(function CloudCeiling32(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), children);
});
var CloudCeiling24 = /*#__PURE__*/React.forwardRef(function CloudCeiling24(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), children);
});
var CloudCeiling20 = /*#__PURE__*/React.forwardRef(function CloudCeiling20(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), children);
});
var CloudCeiling16 = /*#__PURE__*/React.forwardRef(function CloudCeiling16(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), children);
});
var CloudFoundry_132 = /*#__PURE__*/React.forwardRef(function CloudFoundry_132(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
  })), children);
});
var CloudFoundry_124 = /*#__PURE__*/React.forwardRef(function CloudFoundry_124(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
  })), children);
});
var CloudFoundry_120 = /*#__PURE__*/React.forwardRef(function CloudFoundry_120(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
  })), children);
});
var CloudFoundry_116 = /*#__PURE__*/React.forwardRef(function CloudFoundry_116(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
  })), children);
});
var CloudFoundry_232 = /*#__PURE__*/React.forwardRef(function CloudFoundry_232(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
  })), children);
});
var CloudFoundry_224 = /*#__PURE__*/React.forwardRef(function CloudFoundry_224(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
  })), children);
});
var CloudFoundry_220 = /*#__PURE__*/React.forwardRef(function CloudFoundry_220(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
  })), children);
});
var CloudFoundry_216 = /*#__PURE__*/React.forwardRef(function CloudFoundry_216(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
  })), children);
});
var CloudRegistry32 = /*#__PURE__*/React.forwardRef(function CloudRegistry32(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), children);
});
var CloudRegistry24 = /*#__PURE__*/React.forwardRef(function CloudRegistry24(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), children);
});
var CloudRegistry20 = /*#__PURE__*/React.forwardRef(function CloudRegistry20(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), children);
});
var CloudRegistry16 = /*#__PURE__*/React.forwardRef(function CloudRegistry16(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), children);
});
var CloudSatellite32 = /*#__PURE__*/React.forwardRef(function CloudSatellite32(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var CloudSatellite24 = /*#__PURE__*/React.forwardRef(function CloudSatellite24(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var CloudSatellite20 = /*#__PURE__*/React.forwardRef(function CloudSatellite20(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var CloudSatellite16 = /*#__PURE__*/React.forwardRef(function CloudSatellite16(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var CloudSatelliteConfig32 = /*#__PURE__*/React.forwardRef(function CloudSatelliteConfig32(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudSatelliteConfig24 = /*#__PURE__*/React.forwardRef(function CloudSatelliteConfig24(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudSatelliteConfig20 = /*#__PURE__*/React.forwardRef(function CloudSatelliteConfig20(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudSatelliteConfig16 = /*#__PURE__*/React.forwardRef(function CloudSatelliteConfig16(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudSatelliteLink32 = /*#__PURE__*/React.forwardRef(function CloudSatelliteLink32(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), children);
});
var CloudSatelliteLink24 = /*#__PURE__*/React.forwardRef(function CloudSatelliteLink24(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), children);
});
var CloudSatelliteLink20 = /*#__PURE__*/React.forwardRef(function CloudSatelliteLink20(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), children);
});
var CloudSatelliteLink16 = /*#__PURE__*/React.forwardRef(function CloudSatelliteLink16(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), children);
});
var CloudSatelliteServices32 = /*#__PURE__*/React.forwardRef(function CloudSatelliteServices32(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudSatelliteServices24 = /*#__PURE__*/React.forwardRef(function CloudSatelliteServices24(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudSatelliteServices20 = /*#__PURE__*/React.forwardRef(function CloudSatelliteServices20(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudSatelliteServices16 = /*#__PURE__*/React.forwardRef(function CloudSatelliteServices16(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
var CloudServices32 = /*#__PURE__*/React.forwardRef(function CloudServices32(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), children);
});
var CloudServices24 = /*#__PURE__*/React.forwardRef(function CloudServices24(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), children);
});
var CloudServices20 = /*#__PURE__*/React.forwardRef(function CloudServices20(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), children);
});
var CloudServices16 = /*#__PURE__*/React.forwardRef(function CloudServices16(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), children);
});
var Cloudy32 = /*#__PURE__*/React.forwardRef(function Cloudy32(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), children);
});
var Cloudy24 = /*#__PURE__*/React.forwardRef(function Cloudy24(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), children);
});
var Cloudy20 = /*#__PURE__*/React.forwardRef(function Cloudy20(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), children);
});
var Cloudy16 = /*#__PURE__*/React.forwardRef(function Cloudy16(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), children);
});
var WatsonHealthCobbAngle32 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle32(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
  })), children);
});
var WatsonHealthCobbAngle24 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle24(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
  })), children);
});
var WatsonHealthCobbAngle20 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle20(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
  })), children);
});
var WatsonHealthCobbAngle16 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle16(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
  })), children);
});
var Code32 = /*#__PURE__*/React.forwardRef(function Code32(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), children);
});
var Code24 = /*#__PURE__*/React.forwardRef(function Code24(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), children);
});
var Code20 = /*#__PURE__*/React.forwardRef(function Code20(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), children);
});
var Code16 = /*#__PURE__*/React.forwardRef(function Code16(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), children);
});
var CodeHide32 = /*#__PURE__*/React.forwardRef(function CodeHide32(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), children);
});
var CodeHide24 = /*#__PURE__*/React.forwardRef(function CodeHide24(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), children);
});
var CodeHide20 = /*#__PURE__*/React.forwardRef(function CodeHide20(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), children);
});
var CodeHide16 = /*#__PURE__*/React.forwardRef(function CodeHide16(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), children);
});
var CodeReference32 = /*#__PURE__*/React.forwardRef(function CodeReference32(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), children);
});
var CodeReference24 = /*#__PURE__*/React.forwardRef(function CodeReference24(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), children);
});
var CodeReference20 = /*#__PURE__*/React.forwardRef(function CodeReference20(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), children);
});
var CodeReference16 = /*#__PURE__*/React.forwardRef(function CodeReference16(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), children);
});
var CodeSigningService32 = /*#__PURE__*/React.forwardRef(function CodeSigningService32(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
  })), children);
});
var CodeSigningService24 = /*#__PURE__*/React.forwardRef(function CodeSigningService24(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
  })), children);
});
var CodeSigningService20 = /*#__PURE__*/React.forwardRef(function CodeSigningService20(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
  })), children);
});
var CodeSigningService16 = /*#__PURE__*/React.forwardRef(function CodeSigningService16(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
  })), children);
});
var Cognitive32 = /*#__PURE__*/React.forwardRef(function Cognitive32(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
  })), children);
});
var Cognitive24 = /*#__PURE__*/React.forwardRef(function Cognitive24(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
  })), children);
});
var Cognitive20 = /*#__PURE__*/React.forwardRef(function Cognitive20(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
  })), children);
});
var Cognitive16 = /*#__PURE__*/React.forwardRef(function Cognitive16(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
  })), children);
});

export { ChevronRight16, ChevronRight20, ChevronRightGlyph, ChevronSort16, ChevronSort20, ChevronSort24, ChevronSort32, ChevronSortDown16, ChevronSortDown20, ChevronSortDown24, ChevronSortDown32, ChevronSortUp16, ChevronSortUp20, ChevronSortUp24, ChevronSortUp32, ChevronUp16, ChevronUp20, ChevronUp24, ChevronUp32, ChevronUpGlyph, Chip16, Chip20, Chip24, Chip32, Choices16, Choices20, Choices24, Choices32, ChooseItem16, ChooseItem20, ChooseItem24, ChooseItem32, ChoroplethMap16, ChoroplethMap20, ChoroplethMap24, ChoroplethMap32, CicsCmas16, CicsCmas20, CicsCmas24, CicsCmas32, CicsExplorer16, CicsExplorer20, CicsExplorer24, CicsExplorer32, CicsRegion16, CicsRegion20, CicsRegion24, CicsRegion32, CicsRegionRouting16, CicsRegionRouting20, CicsRegionRouting24, CicsRegionRouting32, CicsRegionTarget16, CicsRegionTarget20, CicsRegionTarget24, CicsRegionTarget32, CicsSystemGroup16, CicsSystemGroup20, CicsSystemGroup24, CicsSystemGroup32, CicsWuiRegion16, CicsWuiRegion20, CicsWuiRegion24, CicsWuiRegion32, Cicsplex16, Cicsplex20, Cicsplex24, Cicsplex32, CircleDash16, CircleDash20, CircleDash24, CircleDash32, CircleFillGlyph, CircleFilled16, CircleFilled20, CircleFilled24, CircleFilled32, CirclePacking16, CirclePacking20, CirclePacking24, CirclePacking32, CircleSolid16, CircleSolid20, CircleSolid24, CircleSolid32, CircleStrokeGlyph, Classification16, Classification20, Classification24, Classification32, ClassifierLanguage16, ClassifierLanguage20, ClassifierLanguage24, ClassifierLanguage32, Clean16, Clean20, Clean24, Clean32, Close16, Close20, Close24, Close32, CloseFilled16, CloseFilled20, CloseFilled24, CloseFilled32, CloseOutline16, CloseOutline20, CloseOutline24, CloseOutline32, ClosedCaption16, ClosedCaption20, ClosedCaption24, ClosedCaption32, ClosedCaptionAlt16, ClosedCaptionAlt20, ClosedCaptionAlt24, ClosedCaptionAlt32, ClosedCaptionFilled16, ClosedCaptionFilled20, ClosedCaptionFilled24, ClosedCaptionFilled32, Cloud16, Cloud20, Cloud24, Cloud32, CloudAlerting16, CloudAlerting20, CloudAlerting24, CloudAlerting32, CloudApp16, CloudApp20, CloudApp24, CloudApp32, CloudAuditing16, CloudAuditing20, CloudAuditing24, CloudAuditing32, CloudCeiling16, CloudCeiling20, CloudCeiling24, CloudCeiling32, CloudDataOps16, CloudDataOps20, CloudDataOps24, CloudDataOps32, CloudDownload16, CloudDownload20, CloudDownload24, CloudDownload32, CloudFoundry_116, CloudFoundry_120, CloudFoundry_124, CloudFoundry_132, CloudFoundry_216, CloudFoundry_220, CloudFoundry_224, CloudFoundry_232, CloudLightning16, CloudLightning20, CloudLightning24, CloudLightning32, CloudLogging16, CloudLogging20, CloudLogging24, CloudLogging32, CloudMonitoring16, CloudMonitoring20, CloudMonitoring24, CloudMonitoring32, CloudOffline16, CloudOffline20, CloudOffline24, CloudOffline32, CloudRain16, CloudRain20, CloudRain24, CloudRain32, CloudRegistry16, CloudRegistry20, CloudRegistry24, CloudRegistry32, CloudSatellite16, CloudSatellite20, CloudSatellite24, CloudSatellite32, CloudSatelliteConfig16, CloudSatelliteConfig20, CloudSatelliteConfig24, CloudSatelliteConfig32, CloudSatelliteLink16, CloudSatelliteLink20, CloudSatelliteLink24, CloudSatelliteLink32, CloudSatelliteServices16, CloudSatelliteServices20, CloudSatelliteServices24, CloudSatelliteServices32, CloudServiceManagement16, CloudServiceManagement20, CloudServiceManagement24, CloudServiceManagement32, CloudServices16, CloudServices20, CloudServices24, CloudServices32, CloudSnow16, CloudSnow20, CloudSnow24, CloudSnow32, CloudUpload16, CloudUpload20, CloudUpload24, CloudUpload32, Cloudy16, Cloudy20, Cloudy24, Cloudy32, Code16, Code20, Code24, Code32, CodeHide16, CodeHide20, CodeHide24, CodeHide32, CodeReference16, CodeReference20, CodeReference24, CodeReference32, CodeSigningService16, CodeSigningService20, CodeSigningService24, CodeSigningService32, Cognitive16, Cognitive20, Cognitive24, Cognitive32, QCircuitComposer16, QCircuitComposer20, QCircuitComposer24, QCircuitComposer32, WatsonHealthCircleMeasurement16, WatsonHealthCircleMeasurement20, WatsonHealthCircleMeasurement24, WatsonHealthCircleMeasurement32, WatsonHealthCobbAngle16, WatsonHealthCobbAngle20, WatsonHealthCobbAngle24, WatsonHealthCobbAngle32 };
